// import React, { useState } from "react";
// import { useStateContext } from "../contexts/ContextProvider";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// const API_URL=process.env.REACT_APP_API_URL_V;
// const EditModal = ({ data, onClose, setIsEditModalOpen,fetchDataFromApkMaster }) => {
//   const { currentColor } = useStateContext();
//   const [selectedDocument, setSelectedDocument] = useState(null);

//   const [selectedThumbnail, setSelectedThumbnail] = useState(null);

//   const [formDatas, setFormDatas] = useState({ ...data });
//   const [selectedDocumentPath, setSelectedDocumentPath] = useState(`Existing Document: ${formDatas.file.originalname}`);
//   const [selectedThumbnailPath, setSelectedThumbnailPath] = useState(`Existing Document: ${formDatas.thumbnail.split('\\').pop()}`);

//   const [updatedname, setUpdatedName] = useState(formDatas.name);
//   const [updatedstatus, setUpdatedStatus] = useState(formDatas.status);

//   const handleInputChange = (e) => {
//     setUpdatedName(e.target.value);
//     console.log(updatedname);
//     // setFormData({ ...formData, [name]: value });
//   };

//   const accessToken = localStorage.getItem("accesstoken");

//   const handleStatusChange = (e) => {
//     const { name, value } = e.target;
//     setUpdatedStatus(e.target.value);
//     // setFormData({ ...formData, [name]: value });
//   };
//   const formdatas = {
//     name: updatedname,
//     status: updatedstatus,
//     apk: selectedDocument,
//     thumbnail: selectedThumbnail,
//   };

//   const handleUpdate = async (e) => {
//     e.preventDefault();

//     try {
//       const formData = new FormData();
//       console.log(
//         updatedname,
//         updatedstatus,
//         selectedDocument,
//         selectedThumbnail
//       );
//       if (updatedname) {
//         formData.append("name", updatedname);
//       }
//       if (updatedstatus) {
//         formData.append("status", updatedstatus);
//       }
//       if (!(selectedDocument == null)) {
//         formData.append("apk", selectedDocument);
//       }
//       if (!(selectedThumbnail == null)) {
//         formData.append("thumbnail", selectedThumbnail);
//       }

//       const response = await fetch(
//          `${API_URL}/apkMaster/${formDatas.uid}`,
//         {
//           method: "PUT",
//           headers: {
//             "x-auth-token": accessToken,
//           },
//           body: formData,
//         }
//       );
//       console.log(response);

//       if (response.ok) {
//         fetchDataFromApkMaster();
//         toast.success("Data updated successfully", {
//           position: "bottom-right",
//           autoClose: 3000,
//           hideProgressBar: false,
//           closeOnClick: true,
//           pauseOnHover: true,
//           draggable: true,
//           progress: undefined,
//         });
//         console.log(`APK with UID ${formdatas.uid} updated successfully`);
//         // window.location.reload();

//       } else {
//         throw new Error("Failed to update APK");
//       }

//     } catch (error) {
//       console.error("Error updating APK:", error);
//       toast.error("Error updating data", {
//         position: "bottom-right",
//         autoClose: 3000,
//         hideProgressBar: false,
//         closeOnClick: true,
//         pauseOnHover: true,
//         draggable: true,
//         progress: undefined,
//       });
//     }

//     setIsEditModalOpen(false);
//     // Perform your update logic with formdatas

//     onClose();
//   };
//   const handleDocumentChange = (e) => {
//     const file =
//       e.target.files[0] || (e.dataTransfer && e.dataTransfer.files[0]);
//     console.log(file);
//     setSelectedDocument(file);

//     if (file) {
//       setSelectedDocumentPath(`Selected Document: ${file.name}`);
//     } else {
//       setSelectedDocumentPath(null);
//     }
//   };

//   const handleThumbnailChange = (e) => {
//     const file =
//       e.target.files[0] || (e.dataTransfer && e.dataTransfer.files[0]);
//     setSelectedThumbnail(file);
//     // setFormData({...formData,thumbnail:file});
//     if (file) {
//       setSelectedThumbnailPath(`Selected Thumbnail: ${file.name}`);
//     } else {
//       setSelectedThumbnailPath(null);
//     }
//   };

//   return (
//     <div className="modal-overlay fixed inset-0 bg-gray-500 bg-opacity-75 flex items-center justify-center">
//       <div className="modal bg-white w-full max-w-md p-6 rounded-lg">
//         {/* Modal content */}
//         <div className="relative bg-white rounded-lg shadow">
//           {/* Modal header */}
//           <div className="flex items-center justify-between p-4 md:p-5 border-b rounded-t">
//             <h3 className="text-lg font-semibold text-gray-900">
//               Edit APK Details
//             </h3>
//             <button
//               type="button"
//               className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center"
//               onClick={onClose}
//             >
//               <svg
//                 className="w-3 h-3"
//                 aria-hidden="true"
//                 xmlns="http://www.w3.org/2000/svg"
//                 fill="none"
//                 viewBox="0 0 14 14"
//               >
//                 <path
//                   stroke="currentColor"
//                   strokeLinecap="round"
//                   strokeLinejoin="round"
//                   strokeWidth="2"
//                   d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
//                 ></path>
//               </svg>
//               <span className="sr-only">Close modal</span>
//             </button>
//           </div>

//           <div className="max-h-80 overflow-y-auto relative">
//           <form
//             className="p-4 md:p-5"
//             onSubmit={handleUpdate}
//             encType="multipart/form-data"
//           >
//             <div className="grid gap-4 mb-4">
//               <div>
//                 <label
//                   htmlFor="name"
//                   className="block mb-2 text-sm font-medium text-gray-900"
//                 >
//                   Apk Name
//                 </label>
//                 <div className="flex items-center">
//                   <input
//                     type="text"
//                     name="name"
//                     id="name"
//                     value={updatedname} //
//                     onChange={handleInputChange}
//                     className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5"
//                     placeholder="Type tenant name"
//                     required=""
//                   />
//                 </div>
//               </div>
//               <div>
//                 <label
//                   htmlFor="uid"
//                   className="block mb-2 text-sm font-medium text-gray-900"
//                 >
//                   UID
//                 </label>
//                 <div className="flex items-center">
//                   <input
//                     type="text"
//                     name="uid"
//                     id="uid"
//                     value={formDatas.uid}
//                     onChange={handleInputChange}
//                     className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5"
//                     placeholder="Type tenant ID"
//                     required=""
//                     readOnly
//                     style={{ color: "#808080", cursor: "not-allowed" }}
//                   />
//                 </div>
//               </div>
//               <div>
//                 <label className="block mb-2 text-sm font-medium text-gray-900">
//                   Attach Document
//                 </label>
//                 <label
//                   className="flex cursor-pointer appearance-none justify-center rounded-md border border-dashed border-gray-300 bg-white px-3 py-6 text-sm transition hover:border-gray-400 focus:border-solid focus:border-blue-600 focus:outline-none focus:ring-1 focus:ring-blue-600 disabled:cursor-not-allowed disabled:bg-gray-200 disabled:opacity-75"
//                   tabIndex="0"
//                 >
//                   <span className="flex items-center space-x-2">
//                   <svg className="h-6 w-6 stroke-gray-400" viewBox="0 0 256 256">
//                     <path
//                       d="M96,208H72A56,56,0,0,1,72,96a57.5,57.5,0,0,1,13.9,1.7"
//                       fill="none"
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                       strokeWidth={24}
//                     />
//                     <path
//                       d="M80,128a80,80,0,1,1,144,48"
//                       fill="none"
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                       strokeWidth={24}
//                     />
//                     <polyline
//                       points="118.1 161.9 152 128 185.9 161.9"
//                       fill="none"
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                       strokeWidth={24}
//                     />
//                     <line
//                       x1={152}
//                       y1={208}
//                       x2={152}
//                       y2={128}
//                       fill="none"
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                       strokeWidth={24}
//                     />
//                   </svg>
//                   <span className="text-xs font-medium text-gray-600">
//                     Drop files to Attach, or
//                     <span className="text-blue-600 underline">browse</span>
//                   </span>
//                 </span>

//                   <input
//                     id="documentUpload"
//                     type="file"
//                     className="hidden"
//                     onChange={handleDocumentChange}
//                     accept=".apk"
//                   />
//                 </label>
//               </div>
//               {selectedDocumentPath && (
//                 <p className="text-gray-500 text-sm">{selectedDocumentPath}</p>
//               )}

//               <div>
//                 <label className="block mb-2 text-sm font-medium text-gray-900">
//                   Attach Thumbnail
//                 </label>
//                 <label
//                   className="flex cursor-pointer appearance-none justify-center rounded-md border border-dashed border-gray-300 bg-white px-3 py-6 text-sm transition hover:border-gray-400 focus:border-solid focus:border-blue-600 focus:outline-none focus:ring-1 focus:ring-blue-600 disabled:cursor-not-allowed disabled:bg-gray-200 disabled:opacity-75"
//                   tabIndex="0"
//                 >
//                   <span className="flex items-center space-x-2">
//                       <svg className="h-6 w-6 stroke-gray-400" viewBox="0 0 256 256">
//                         <path
//                           d="M96,208H72A56,56,0,0,1,72,96a57.5,57.5,0,0,1,13.9,1.7"
//                           fill="none"
//                           strokeLinecap="round"
//                           strokeLinejoin="round"
//                           strokeWidth={24}
//                         />
//                         <path
//                           d="M80,128a80,80,0,1,1,144,48"
//                           fill="none"
//                           strokeLinecap="round"
//                           strokeLinejoin="round"
//                           strokeWidth={24}
//                         />
//                         <polyline
//                           points="118.1 161.9 152 128 185.9 161.9"
//                           fill="none"
//                           strokeLinecap="round"
//                           strokeLinejoin="round"
//                           strokeWidth={24}
//                         />
//                         <line
//                           x1={152}
//                           y1={208}
//                           x2={152}
//                           y2={128}
//                           fill="none"
//                           strokeLinecap="round"
//                           strokeLinejoin="round"
//                           strokeWidth={24}
//                         />
//                       </svg>
//                       <span className="text-xs font-medium text-gray-600">
//                         Drop files to Attach, or
//                         <span className="text-blue-600 underline">browse</span>
//                       </span>
//                     </span>

//                   <input
//                     id="thumbnailUpload"
//                     type="file"
//                     className="hidden"
//                     onChange={handleThumbnailChange}
//                     accept=".png,jpg,jpeg"
//                   />
//                 </label>
//               </div>
//               {selectedThumbnailPath && (
//                 <p className="text-gray-500 text-sm">{selectedThumbnailPath}</p>
//               )}
//               <div>
//                 <label className="block mb-2 text-sm font-medium text-gray-900">
//                   Status
//                 </label>
//                 <div className="flex items-center">
//                   <label className="inline-flex items-center">
//                     <input
//                       type="radio"
//                       name="status"
//                       value="active"
//                       checked={updatedstatus === "active"}
//                       onChange={handleStatusChange}
//                       className="form-radio text-primary-600"
//                     />
//                     <span className="ml-2">Active</span>
//                   </label>
//                   <label className="inline-flex items-center ml-4">
//                     <input
//                       type="radio"
//                       name="status"
//                       value="inactive"
//                       checked={updatedstatus === "inactive"}
//                       onChange={handleStatusChange}
//                       className="form-radio text-red-600"
//                     />
//                     <span className="ml-2">Inactive</span>
//                   </label>
//                 </div>
//               </div>
//             </div>
//             <div className="flex justify-end">
//               <button
//                 type="submit"
//                 style={{ backgroundColor: currentColor, color: "white" }}
//                 className="text-white inline-flex items-center bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5"
//               >
//                 {/*  <svg
//                 className="me-1 -ms-1 w-5 h-5"
//                 fill="currentColor"
//                 viewBox="0 0 20 20"
//                 xmlns="http://www.w3.org/2000/svg"
//               >
//                 <path
//                   fillRule="evenodd"
//                   d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z"
//                   clipRule="evenodd"
//                 ></path>
//               </svg> */}
//                 Update
//               </button>
//             </div>
//           </form>
//           </div>
//         </div>
//       </div>
//       <ToastContainer />
//     </div>

//   );
// };

// export default EditModal;

import React, { useState } from "react";
import { useStateContext } from "../contexts/ContextProvider";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
const API_URL = process.env.REACT_APP_API_URL_V;
const EditModal = ({
  data,
  onClose,
  setIsEditModalOpen,
  fetchDataFromApkMaster,
}) => {
  const { currentColor } = useStateContext();
  const [selectedDocument, setSelectedDocument] = useState(null);
  const [selectedThumbnail, setSelectedThumbnail] = useState(null);

  const [formDatas, setFormDatas] = useState({ ...data });
  const [selectedDocumentPath, setSelectedDocumentPath] = useState(
    `Existing Document: ${formDatas.file.originalname}`
  );
  const [selectedThumbnailPath, setSelectedThumbnailPath] = useState(
    `Existing Document: ${formDatas.thumbnail.split("\\").pop()}`
  );

  const [updatedname, setUpdatedName] = useState(formDatas.name);
  const [updatedstatus, setUpdatedStatus] = useState(formDatas.status);
  const [updatedPackageName, setUpdatedPackageName] = useState(
    formDatas.packageName
  );
  const [updatedVersion, setUpdatedVersion] = useState(formDatas.version);

  const handleInputChange = (e) => {
    setUpdatedName(e.target.value);
    // setFormData({ ...formData, [name]: value });
  };
  const handlePackageNameChange = (e) => {
    setUpdatedPackageName(e.target.value);
    // setFormData({ ...formData, [name]: value });
  };
  const handleVersionChange = (e) => {
    setUpdatedVersion(e.target.value);
    // setFormData({ ...formData, [name]: value });
  };

  const accessToken = localStorage.getItem("accesstoken");

  const handleStatusChange = (e) => {
    const { name, value } = e.target;
    setUpdatedStatus(e.target.value);
    // setFormData({ ...formData, [name]: value });
  };
  const formdatas = {
    name: updatedname,
    status: updatedstatus,
    apk: selectedDocument,
    thumbnail: selectedThumbnail,
    packageName: updatedPackageName,
    version: updatedVersion,
  };

  const handleUpdate = async (e) => {
    e.preventDefault();

    try {
      const formData = new FormData();

      if (updatedname) {
        formData.append("name", updatedname);
      }
      if (updatedstatus) {
        formData.append("status", updatedstatus);
      }
      if (updatedPackageName) {
        formData.append("packageName", updatedPackageName);
      }
      if (updatedVersion) {
        formData.append("version", updatedVersion);
      }
      if (!(selectedDocument == null)) {
        formData.append("apk", selectedDocument);
      }
      if (!(selectedThumbnail == null)) {
        formData.append("thumbnail", selectedThumbnail);
      }

      const response = await fetch(`${API_URL}/apkMaster/${formDatas.uid}`, {
        method: "PUT",
        headers: {
          "x-auth-token": accessToken,
        },
        body: formData,
      });

      if (response.ok) {
        fetchDataFromApkMaster();
        toast.success("Data updated successfully", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        // window.location.reload();
      } else {
        throw new Error("Failed to update APK");
      }
    } catch (error) {
      console.error("Error updating APK:", error);
      toast.error("Error updating data", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }

    setIsEditModalOpen(false);
    // Perform your update logic with formdatas

    onClose();
  };
  const handleDocumentChange = (e) => {
    const file =
      e.target.files[0] || (e.dataTransfer && e.dataTransfer.files[0]);
    setSelectedDocument(file);

    if (file) {
      setSelectedDocumentPath(`Selected Document: ${file.name}`);
    } else {
      setSelectedDocumentPath(null);
    }
  };

  const handleThumbnailChange = (e) => {
    const file =
      e.target.files[0] || (e.dataTransfer && e.dataTransfer.files[0]);
    setSelectedThumbnail(file);
    // setFormData({...formData,thumbnail:file});
    if (file) {
      setSelectedThumbnailPath(`Selected Thumbnail: ${file.name}`);
    } else {
      setSelectedThumbnailPath(null);
    }
  };

  return (
    <div className="modal-overlay fixed inset-0 bg-gray-500 bg-opacity-75 flex items-center justify-center">
      <div className="modal bg-white w-full max-w-md p-6 rounded-lg">
        {/* Modal content */}
        <div className="relative bg-white rounded-lg shadow">
          {/* Modal header */}
          <div className="flex items-center justify-between p-4 md:p-5 border-b rounded-t">
            <h3 className="text-lg font-semibold text-gray-900">
              Edit APK Details
            </h3>
            <button
              type="button"
              className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center"
              onClick={onClose}
            >
              <svg
                className="w-3 h-3"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 14 14"
              >
                <path
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
                ></path>
              </svg>
              <span className="sr-only">Close modal</span>
            </button>
          </div>
          <div className="max-h-80 overflow-y-auto relative">
            <form
              className="p-4 md:p-5"
              onSubmit={handleUpdate}
              encType="multipart/form-data"
            >
              <div className="grid gap-4 mb-4">
                <div>
                  <label
                    htmlFor="name"
                    className="block mb-2 text-sm font-medium text-gray-900"
                  >
                    Apk Name
                  </label>
                  <div className="flex items-center">
                    <input
                      type="text"
                      name="name"
                      id="name"
                      value={updatedname}
                      onChange={handleInputChange}
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5"
                      required=""
                    />
                  </div>
                </div>
                <div>
                  <label
                    htmlFor="uid"
                    className="block mb-2 text-sm font-medium text-gray-900"
                  >
                    UID
                  </label>
                  <div className="flex items-center">
                    <input
                      type="text"
                      name="uid"
                      id="uid"
                      value={formDatas.uid}
                      onChange={handleInputChange}
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5"
                      placeholder="Type tenant ID"
                      required=""
                      readOnly
                      style={{ color: "#808080", cursor: "not-allowed" }}
                    />
                  </div>
                </div>
                <div>
                  <label
                    htmlFor="packageName"
                    className="block mb-2 text-sm font-medium text-gray-900"
                  >
                    Package Name
                  </label>
                  <div className="flex items-center">
                    <input
                      type="text"
                      name="packageName"
                      id="packageName"
                      value={updatedPackageName} //
                      onChange={handlePackageNameChange}
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5"
                      required=""
                    />
                  </div>
                </div>
                <div>
                  <label className="block mb-2 text-sm font-medium text-gray-900">
                    Attach Document
                  </label>
                  <label
                    className="flex cursor-pointer appearance-none justify-center rounded-md border border-dashed border-gray-300 bg-white px-3 py-6 text-sm transition hover:border-gray-400 focus:border-solid focus:border-blue-600 focus:outline-none focus:ring-1 focus:ring-blue-600 disabled:cursor-not-allowed disabled:bg-gray-200 disabled:opacity-75"
                    tabIndex="0"
                  >
                    <span className="flex items-center space-x-2">
                      <svg
                        className="h-6 w-6 stroke-gray-400"
                        viewBox="0 0 256 256"
                      >
                        <path
                          d="M96,208H72A56,56,0,0,1,72,96a57.5,57.5,0,0,1,13.9,1.7"
                          fill="none"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={24}
                        />
                        <path
                          d="M80,128a80,80,0,1,1,144,48"
                          fill="none"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={24}
                        />
                        <polyline
                          points="118.1 161.9 152 128 185.9 161.9"
                          fill="none"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={24}
                        />
                        <line
                          x1={152}
                          y1={208}
                          x2={152}
                          y2={128}
                          fill="none"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={24}
                        />
                      </svg>
                      <span className="text-xs font-medium text-gray-600">
                        Drop files to Attach, or
                        <span className="text-blue-600 underline">browse</span>
                      </span>
                    </span>

                    <input
                      id="documentUpload"
                      type="file"
                      className="hidden"
                      onChange={handleDocumentChange}
                      accept=".apk"
                    />
                  </label>
                </div>
                {selectedDocumentPath && (
                  <p className="text-gray-500 text-sm">
                    {selectedDocumentPath}
                  </p>
                )}

                <div>
                  <label
                    htmlFor="version"
                    className="block mb-2 text-sm font-medium text-gray-900"
                  >
                    Version
                  </label>
                  <div className="flex items-center">
                    <input
                      type="text"
                      name="version"
                      id="version"
                      value={updatedVersion}
                      onChange={handleVersionChange}
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5"
                      required=""
                    />
                  </div>
                </div>

                <div>
                  <label className="block mb-2 text-sm font-medium text-gray-900">
                    Attach Thumbnail
                  </label>
                  <label
                    className="flex cursor-pointer appearance-none justify-center rounded-md border border-dashed border-gray-300 bg-white px-3 py-6 text-sm transition hover:border-gray-400 focus:border-solid focus:border-blue-600 focus:outline-none focus:ring-1 focus:ring-blue-600 disabled:cursor-not-allowed disabled:bg-gray-200 disabled:opacity-75"
                    tabIndex="0"
                  >
                    <span className="flex items-center space-x-2">
                      <svg
                        className="h-6 w-6 stroke-gray-400"
                        viewBox="0 0 256 256"
                      >
                        <path
                          d="M96,208H72A56,56,0,0,1,72,96a57.5,57.5,0,0,1,13.9,1.7"
                          fill="none"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={24}
                        />
                        <path
                          d="M80,128a80,80,0,1,1,144,48"
                          fill="none"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={24}
                        />
                        <polyline
                          points="118.1 161.9 152 128 185.9 161.9"
                          fill="none"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={24}
                        />
                        <line
                          x1={152}
                          y1={208}
                          x2={152}
                          y2={128}
                          fill="none"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={24}
                        />
                      </svg>
                      <span className="text-xs font-medium text-gray-600">
                        Drop files to Attach, or
                        <span className="text-blue-600 underline">browse</span>
                      </span>
                    </span>

                    <input
                      id="thumbnailUpload"
                      type="file"
                      className="hidden"
                      onChange={handleThumbnailChange}
                      accept=".png,jpg,jpeg"
                    />
                  </label>
                </div>
                {selectedThumbnailPath && (
                  <p className="text-gray-500 text-sm">
                    {selectedThumbnailPath}
                  </p>
                )}
                <div>
                  <label className="block mb-2 text-sm font-medium text-gray-900">
                    Status
                  </label>
                  <div className="flex items-center">
                    <label className="inline-flex items-center">
                      <input
                        type="radio"
                        name="status"
                        value="active"
                        checked={updatedstatus === "active"}
                        onChange={handleStatusChange}
                        className="form-radio text-primary-600"
                      />
                      <span className="ml-2">Active</span>
                    </label>
                    <label className="inline-flex items-center ml-4">
                      <input
                        type="radio"
                        name="status"
                        value="inactive"
                        checked={updatedstatus === "inactive"}
                        onChange={handleStatusChange}
                        className="form-radio text-red-600"
                      />
                      <span className="ml-2">Inactive</span>
                    </label>
                  </div>
                </div>
              </div>
              <div className="flex justify-end">
                <button
                  type="submit"
                  style={{ backgroundColor: currentColor, color: "white" }}
                  className="text-white inline-flex items-center bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5"
                >
                  {/*  <svg
                className="me-1 -ms-1 w-5 h-5"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
>
<path
                  fillRule="evenodd"
                  d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z"
                  clipRule="evenodd"
></path>
</svg> */}
                  Update
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <ToastContainer />
    </div>
  );
};

export default EditModal;
